module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/madh2-8a73850cb7a2a4eabb7209715c0a6bb6.jpg";